import { fetchStrapi } from './strapi';

export interface LegalSection {
  title: string;
  content: string;
}

export interface Datenschutz {
  title: string;
  sections: LegalSection[];
}

export async function fetchDatenschutz(): Promise<Datenschutz | null> {
  try {
    const response = await fetchStrapi<any>('/datenschutz?populate=*');

    if (!response.data) {
      return null;
    }

    const data = response.data;

    return {
      title: data.titel || '',
      sections: (data.abschnitte || []).map((s: any) => ({
        title: s.titel || '',
        content: s.inhalt || '',
      })),
    };
  } catch (error) {
    console.error('Error fetching datenschutz from Strapi:', error);
    return null;
  }
}
